import {createApiFetcher} from "@variocube/app-ui";
import {getCubeCenterBaseUrl} from "../utils";
import {EndpointParameters, Method} from "./client.gen";

const centerBaseUrl = getCubeCenterBaseUrl();

async function callApi<T>(method: Method, path: string, params: EndpointParameters | undefined) {
	const {fetch} = createApiFetcher(centerBaseUrl);

	const headers: HeadersInit = params?.body ? {"Content-Type": "application/json"} : {};

	const response = await fetch(path, {
		method,
		body: params?.body ? JSON.stringify(params.body) : undefined,
		headers,
	});

	const contentType = response.headers.get("content-type");

	if (contentType && /application\/.*json/.test(contentType)) {
		return await response.json() as T;
	}
}

interface LocationCodeShape {
	alphabet: string;
	length: number;
}

interface LocationCube {
	hostname: string;
}

export const useCenterApi = () => {
	return {
		getCodeShape: () => callApi<LocationCodeShape>("get", "/api/location/code", undefined),
		getCubeByCode: (code: string) => callApi<LocationCube>("get", `/api/location/code/${code}`, undefined),
	};
};
